import React from "react";
import ButtonIcon from "./ButtonIcon.jsx";

export default function ButtonIconEdit(props) {
    // Combine component className
    const className = ["button-edit-base"];
    Array.isArray(props.className) && className.push.call(className, props.className);
    typeof props.className === "string" && className.push(props.className);

    return (
        <ButtonIcon
            {...props}
            className={className}
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
                    <circle cx="24" cy="24" r="23.5" fill="white" />

                    <path d="M12 31.1114V36H16.8886L31.3069 21.5817L26.4183 16.6931L12 31.1114ZM36 16.8886L31.1114 12L27.8131 15.3112L32.7018 20.1999L36 16.8886Z" />
                </svg>
            }
        />
    );
}
